module.exports = __webpack_public_path__ + "media/images/pc/components/store/icon_store-ccd0fff2078634350fa1f5832882a439.svg";